export function PollDiscordMetaRow({
  statusLabel = "",
  messageUrl = "",
  eventUrl = "",
  pendingSync = false,
  className = "",
  children = null,
}) {
  const normalizedStatus = String(statusLabel || "").trim();
  const normalizedUrl = String(messageUrl || "").trim();
  const normalizedEventUrl = String(eventUrl || "").trim();
  const hasContent = Boolean(normalizedStatus || normalizedUrl || normalizedEventUrl || pendingSync || children);
  if (!hasContent) return null;

  return (
    <div className={`flex flex-wrap items-center gap-2 text-xs text-slate-500 dark:text-slate-400 ${className}`.trim()}>
      {normalizedStatus ? (
        <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-semibold text-slate-600 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-200">
          {normalizedStatus}
        </span>
      ) : null}
      {pendingSync ? (
        <span className="rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs font-semibold text-amber-700 dark:border-amber-700/70 dark:bg-amber-900/30 dark:text-amber-200">
          Sync pending
        </span>
      ) : null}
      {normalizedUrl ? (
        <a
          href={normalizedUrl}
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-slate-200 px-2 py-0.5 text-xs font-semibold text-slate-600 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
        >
          View in Discord
        </a>
      ) : null}
      {normalizedEventUrl ? (
        <a
          href={normalizedEventUrl}
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-xs font-semibold text-indigo-700 transition-colors hover:bg-indigo-100 dark:border-indigo-700/60 dark:bg-indigo-900/30 dark:text-indigo-200 dark:hover:bg-indigo-900/50"
        >
          Discord Event
        </a>
      ) : null}
      {children}
    </div>
  );
}
